import { theme } from "@lvt/material";
import { createStyles, makeStyles } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import PauseIcon from "@material-ui/icons/Pause";
import VideocamIcon from "@material-ui/icons/Videocam";

import { CameraHealth } from "@/api/streamMetadata";
import { UnitHealth } from "@/utilities/types/liveunit";


interface HealthDotProps {
    health?: CameraHealth | UnitHealth; //Health is only optional so that a Skeleton component can infer the size of this dot before the data loads.
    classes?: string;
    size?: number | string;
}

const useStyles = makeStyles(() => {
    return createStyles({
        tooltip: {
            fontSize: "14px",
        },
    });
});

const HealthDot: React.FC<HealthDotProps> = ({
    health = { isFlapping: false, isGradient: false, statusText: "", startColor: "#fff", color: "#fff", overlay: null },
    classes,
    size = "1.5em",
}) => {
    const muiClasses = useStyles();
    let icon;

    if (health.overlay === "/img/pause.svg") {
        icon = <PauseIcon color="secondary" style={{ fontSize: size }}></PauseIcon>;
    } else {
        let color = health.color;

        if (color === "#f9ff07") color = "#F4CD27";

        if (color === "#82C341") color = theme.palette.secondary.main;

        icon = <VideocamIcon style={{ fill: color, fontSize: size }}></VideocamIcon>;
    }

    return (
        <div className={classes}>
            <Tooltip arrow={true} title={health.statusText} placement="top" classes={muiClasses}>
                {icon}
            </Tooltip>
        </div>
    );
};

export default HealthDot;
